import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Distributor } from '../../models/distributor';
import { Response } from '@angular/http';
import { Postcode } from '../../models/postcode';
import { DistributorsService } from '../../preferreddistributors/services/distributors.service';
import { PostcodesService } from '../services/postcodes.service';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import {GroupRightService} from '../../services/group-right.service';
import {GroupRight} from '../../models/group-right';

@Component({
	selector: 'app-postcodes-detail',
	templateUrl: './postcodes-detail.component.html',
	styleUrls: ['./postcodes-detail.component.css']
})
export class PostcodesDetailComponent implements OnInit
{

	private route: ActivatedRoute;
	private router: Router;
	private distributorsService: DistributorsService;
	private postcodesService: PostcodesService;
	private confirmationService: ConfirmationService;
	private messagesService: MessageService;
	private breadcrumbService: BreadcrumbService;
	public postcode: Postcode;
	public distributors: Distributor[];
	public groupRight: GroupRight = null;

	constructor(route: ActivatedRoute,
	            router: Router,
	            distributorsService: DistributorsService,
	            messagesService: MessageService,
	            postcodesService: PostcodesService,
	            breadcrumbService: BreadcrumbService,
				private groupRightService: GroupRightService
	)
	{
		this.route = route;
		this.router = router;
		this.distributorsService = distributorsService;
		this.messagesService = messagesService;
		this.postcodesService = postcodesService;
		this.breadcrumbService = breadcrumbService;
	}

	ngOnInit()
	{
		if (this.route.snapshot.data['groupRights'] instanceof Array) {
			this.groupRight = this.groupRightService.getGroupRightForModule('voorkeurspartners', this.route.snapshot.data['groupRights'])
		}

		if (this.route.snapshot.data['distributors'] instanceof Object && !(this.route.snapshot.data['distributors'] instanceof Response))
		{
			// Distributors was received.
			this.distributors = this.route.snapshot.data['distributors'];
		}
		else
		{
			// We got a unhandled exception, let's show a message.
			this.messagesService.add({
				severity: 'error',
				summary: 'Fout',
				detail: 'Er is een fout opgetreden tijdens het ophalen van de verspreiders.'
			});
		}
		if (this.route.snapshot.data['postcode'] instanceof Object && !(this.route.snapshot.data['postcode'] instanceof Response))
		{
			this.postcode = this.route.snapshot.data['postcode'];
			this.breadcrumbService.addBreadcrumbTranslation('Voorkeurverspreider Bewerken of Toevoegen', this.postcode.postcode.toString());
			if (this.postcode.preferred_distributor != null)
			{
				this.postcode.preferred_distributor = this.distributors.find((distributor) => distributor.id === this.postcode.preferred_distributor.id && distributor.walkday === this.postcode.preferred_walkday);
			}
		}
	}

	public goBack()
	{
		//this.router.navigate(['voorkeurverspreiders']);
	}

	public hasUserAccess(action: string)
	{
		return this.groupRight && this.groupRight[action];
	}

	public attachPreferredDistributor()
	{
		let promise: Promise<Postcode>;
		promise = this.postcodesService.attachPreferredDistributor(this.postcode);

		promise.then((data) => {
			if (data instanceof Response) {
				this.messagesService.add({
					severity: 'error',
					summary: 'Postcode niet opgeslagen',
					detail: 'Er is een fout opgetreden tijdens het opslaan van de verspreider bij postcode.'
				});
			} else {
				this.messagesService.add({
					severity: 'success',
					summary: 'Postcode is opgeslagen',
					detail: 'De postcode is succesvol opgeslagen.'
				});

				//this.router.navigate(['/voorkeurverspreiders']);
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/postcodes/postcodes-detail/postcodes-detail.component.ts